import React, { Component } from 'react'
import PropTypes from 'prop-types'

import _ from 'lodash'

import Section from './components/Section'
import Summary from './components/Summary'

import hocConnect from './hocConnect'

import './style.scss'

@hocConnect
export default class Signals extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        customData: PropTypes.object,
        data: PropTypes.object,
        mainId: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        scrollTo: PropTypes.func.isRequired,
        scrollRefs: PropTypes.object.isRequired,
        // dispatches
        toggleSignalDetail: PropTypes.func.isRequired,
        openLinkagesById: PropTypes.func,
        setupDistraintsById: PropTypes.func,
        signalsOpenCiaNews: PropTypes.func.isRequired,
    }

    render() {
        const {
            module,
            block,
            customData,
            data,
            toggleSignalDetail,
            mainId,
            openLinkagesById,
            setupDistraintsById,
            scrollTo,
            scrollRefs,
            signalsOpenCiaNews,
        } = this.props
        if (!data) return null

        return (
            <div>
                <Summary level={10} />
                <div className={'signals-container'}>
                    {_.map(data, (values, key) => (
                        <Section
                            module={module}
                            block={block}
                            customData={customData}
                            sectionId={key}
                            key={`signals-section-${key}`}
                            signals={values}
                            mainId={mainId}
                            scrollTo={scrollTo}
                            scrollRefs={scrollRefs}
                            // dispatches
                            toggleSignalDetail={toggleSignalDetail}
                            openLinkagesById={openLinkagesById}
                            setupDistraintsById={setupDistraintsById}
                            signalsOpenCiaNews={signalsOpenCiaNews}
                        />
                    ))}
                </div>
            </div>
        )
    }
}
